// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"bad9e6e7","205":"68ef7c83","209":"6c030ecb","375":"3731f4fa","457":"c0b96db9","548":"b43c67d6","551":"29c1fa42","629":"ece76c7c","851":"94648956","873":"c9003570","950":"c431b257"}[chunkId] + ".chunk.js";
};